import { BlockOverrides } from 'baseui/block';
import { StyleObject } from 'styletron-react';

export const SKELETON: StyleObject = {
  width: '144px',
  height: '32px',
  marginBottom: '16px',
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'inline-block',
      width: 'fit-content',
    },
  },
};
